import clsx from "clsx";
import React from "react";
import { FormattedMessage } from "react-intl";

import { LabelRequiredIndicator } from "./label";
import { QuestionTooltip } from "./tooltip";

export function Portlet({
  as: Comp = "section",
  id,
  testId,
  className,
  style,
  children,
}: {
  as?: "main" | "section";
  id?: string;
  testId?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}) {
  return (
    <Comp
      id={id}
      data-testid={testId}
      className={clsx("portlet light bordered", className)}
      style={style}
    >
      {children}
    </Comp>
  );
}

export function PortletTitle({
  as: Comp = "h1",
  id,
  testId,
  iconClassName,
  children,
  displayRequiredFieldsInfo = false,
  floatRightSlot,
}: {
  as?: `h${1 | 2 | 3 | 4 | 5 | 6}`;
  iconClassName: string;
  id?: string;
  testId?: string;
  children: React.ReactNode;
  displayRequiredFieldsInfo?: boolean;
  floatRightSlot?: React.ReactChild;
}) {
  return (
    <div id={id} data-testid={testId} className="portlet-title">
      <div className={clsx("caption", { "col-md-8 col-sm-8 col-xs-8": displayRequiredFieldsInfo })}>
        <i className={clsx(iconClassName, "font-green")} aria-hidden="true" />
        <Comp className="caption-subject font-green bold uppercase tw-inline">{children}</Comp>
      </div>

      {displayRequiredFieldsInfo ? (
        <RequiredFieldsInfo />
      ) : floatRightSlot ? (
        <div className="tw-float-right">{floatRightSlot}</div>
      ) : null}
    </div>
  );
}

function RequiredFieldsInfo() {
  return (
    <div className="col-md-4 col-sm-4 col-xs-4" style={{ padding: "8px 0" }}>
      <div className="tw-inline-flex tw-items-center">
        <LabelRequiredIndicator marginLeft={false} />

        <span className="tw-relative tw-bottom-0.5 tw-whitespace-nowrap tw-font-bold tw-uppercase tw-italic max-sm:tw-text-[8px]">
          <span className="sm:tw-ml-0.5"> - </span>
          <FormattedMessage id="requiredField" />
        </span>

        <QuestionTooltip side="bottom" maxWidth={false} className="tw-relative tw-bottom-0.5">
          <FormattedMessage id="required.fields.tooltip" />
        </QuestionTooltip>
      </div>
    </div>
  );
}
